import React, { useState, useEffect } from "react";
import { message, Upload, Button,Checkbox,Divider ,notification,TreeSelect  ,Col, InputNumber, Row, Slider, Space ,Switch} from "antd";
import { Bar,Column,Pie } from "@ant-design/charts";
import DemoPie from "../Graphs/Pie/Pie"
import "./Billing.scss";

export default function Billing_rr(props) {
  const { objectMap1,objectMap2,objectMap3,objectMap4,rutas,iva, setiva } = props;
  // console.log(datosTotales,'datosTotales')
  // console.log(rutas,'rutas')


  var routes=[];
  var data=[];
  var ant=0;
  var revenues;
  var revenuesacc=0.0;
  var servicetimeacc=0.0;
  var taxesacc=0.0;
  var costacc=0.0;
  var i=1;

  rutas.forEach(element => {
    // console.log(element.tour_info.order_pos,' ',ant)
    if(element.tour_info.order_pos===0){
      revenues=0;
    }else if(element.position==='end'){
      var aux=0
      aux=objectMap2[element.tour_info.order_vehicle].transptype_hourcost/60*objectMap4[element.tour_info.order_tour].duration_time+ 
      objectMap2[element.tour_info.order_vehicle].transptype_fixcost+
      objectMap2[element.tour_info.order_vehicle].transptype_kmcost*
      ((objectMap4[element.tour_info.order_tour].duration_time-servicetimeacc)/60*objectMap2[element.tour_info.order_vehicle].transptype_speed)

      servicetimeacc=0.0
      
      parseInt(element.tour_info.order_vehicle)
      routes.push(<Row justifyContent={'center'}>
      <h1>Route billing {i}: {revenues}€</h1>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
      <h1>Route costs {i}: {aux}€</h1>
      </Row>);

      data.push({
        label: i,
        type: 'revenues',
        value: revenues,
        sex:0,
      })
      data.push({
        label: i,
        type: 'taxes',
        value: parseFloat((revenues*iva*0.01).toFixed(2)),
        // value: parseFloat((revenues/(1-iva*0.01)-revenues).toFixed(2)),
        sex:0,
      })
      data.push({
        label: i,
        type: 'costs',
        value: parseFloat(aux).toFixed(2),
        sex:1,
      })
      // console.log(data)
      revenuesacc=revenuesacc+revenues;
      taxesacc=taxesacc+parseFloat((revenues*iva*0.01).toFixed(2));
      // taxesacc=taxesacc+parseFloat((revenues/(1-iva*0.01)-revenues).toFixed(2));
      costacc=costacc+aux;
      i=i+1;
    }else {
      revenues=parseFloat(element.order_revenue) + revenues
      servicetimeacc=servicetimeacc+parseFloat(element.servicetime1)
    }
    ant=element.tour_info.order_pos
  })

  var datas = [
    {
      type: "Total revenue",
      value: parseFloat((revenuesacc).toFixed(2))
    },
    {
      type: "Total taxes",
      value: parseFloat((taxesacc).toFixed(2))
    },
    {
      type: "Total costs",
      value: parseFloat((costacc).toFixed(2))
    },
  ];

  var config1 = {
    data: data,
    isGroup: true,
    xField: 'value',
    yField: 'label',
    isStack: true,
    groupField: 'sex',
    seriesField: 'type',
    color: ['green','yellow', 'red'],
    label: {
      position: "top",
      layout: [
        { type: "interval-adjust-position" },
        { type: "interval-hide-overlap" },
        { type: "adjust-color" },
      ],
    },
  };

  var config = {
    appendPadding: 10,
    data: datas,
    angleField: "value",
    colorField: "type",
    radius: 1,
    innerRadius: 0.6,
    color: ['green','yellow', 'red'],
    label: {
      type: "inner",
      offset: "-50%",
      content: "{value}",
      autoRotate: false,
      style: {
        textAlign: "center",
        fontSize: 14,
      },
    },
    interactions: [{ type: "element-selected" }, { type: "element-active" }],
    statistic: {
      title: false,
      content: {
        style: {
          whiteSpace: "pre-wrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        content: "",
      },
    },
  };

  return (
    <>
      <h1 className="titulos3" >ECONOMIC PERFORMANCE</h1>
      <Row justify={'center'}>
        <InputNumber
          addonBefore='Taxes'
          addonAfter='%'
          min={0}
          max={100}
          step={1}
          style={{
            margin: '0px 0px 5px 0px',
          }}
          defaultValue={iva}
          onChange={(value)=>{
              setiva(value)
              }}
            />
      </Row>
    <div className="economics" >
      
       
          {/* <Col>
          {routes}
          </Col> */}
            <div  className="economics__chart" >
              <Bar {...config1} />
            </div>
            {/* <Column {...config1} /> */}
            <Pie {...config}/>
    </div>
    </>
  );

 
  
}
